var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-btn",on:{"click":function($event){return _vm.goUrl('/contact')}}},[_vm._v("联系我们")])
}
var staticRenderFns = []

export { render, staticRenderFns }